function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1960(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.06,
    height: 8.64,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 4.32
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.64,
    width: 23.06,
    height: 21.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.74125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 19.605
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30.57,
    width: 23.06,
    height: 27.12,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.612
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 44.13
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.69,
    width: 23.06,
    height: 31.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.612
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 73.275
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.86,
    width: 23.06,
    height: 34.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.562222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 106.345
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 123.83,
    width: 23.06,
    height: 42.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8433333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 144.86
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 165.89,
    width: 23.06,
    height: 46.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.294285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 189
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 212.12,
    width: 23.06,
    height: 47.52,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.294285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 235.88
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 259.63,
    width: 23.06,
    height: 50.79,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.612
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 285.025
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 310.42,
    width: 23.06,
    height: 52.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.612
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 336.5
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 362.58,
    width: 23.06,
    height: 53.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 389.145
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 415.72,
    width: 23.06,
    height: 53.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8433333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 442.41
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 469.1,
    width: 23.06,
    height: 56.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 497.305
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 525.5,
    width: 23.06,
    height: 57.39,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 554.195
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 582.89,
    width: 23.06,
    height: 58.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8433333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 612.01
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 641.13,
    width: 23.06,
    height: 58.87,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.53,
    y: 670.5649999999999
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 0,
    width: 34.95,
    height: 41.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.495
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.535,
    y: 20.625
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.02,
    y: 0,
    width: 35.48,
    height: 41.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.913333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.76,
    y: 20.625
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 0,
    width: 35.86,
    height: 41.25,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.43,
    y: 20.625
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.36,
    y: 0,
    width: 37.99,
    height: 41.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7990000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.35500000000002,
    y: 20.625
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.35,
    y: 0,
    width: 40.18,
    height: 41.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.44,
    y: 20.625
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.53,
    y: 0,
    width: 40.24,
    height: 41.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.748571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.65,
    y: 20.625
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.77,
    y: 0,
    width: 40.54,
    height: 41.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.756666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.04,
    y: 20.625
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.31,
    y: 0,
    width: 40.65,
    height: 41.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.807142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.635,
    y: 20.625
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.96,
    y: 0,
    width: 40.87,
    height: 41.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.838571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.395,
    y: 20.625
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.82,
    y: 0,
    width: 41.18,
    height: 41.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.40999999999997,
    y: 20.625
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.01,
    y: 0,
    width: 41.3,
    height: 41.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.65999999999997,
    y: 20.625
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.3,
    y: 0,
    width: 41.92,
    height: 41.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.15625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.26,
    y: 20.625
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.23,
    y: 0,
    width: 50.14,
    height: 41.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.3000000000001,
    y: 20.625
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.37,
    y: 0,
    width: 50.22,
    height: 41.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.48,
    y: 20.625
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.59,
    y: 0,
    width: 52.02,
    height: 41.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.892857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 620.6,
    y: 20.625
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 646.61,
    y: 0,
    width: 53.39,
    height: 41.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.15625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.3050000000001,
    y: 20.625
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 41.25,
    width: 60.44,
    height: 40.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6972727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 61.585
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 81.92,
    width: 60.44,
    height: 41.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.991666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 102.89500000000001
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 123.87,
    width: 60.44,
    height: 44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.333333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 145.87
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 167.86,
    width: 60.44,
    height: 44.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.956666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 190.16500000000002
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 212.47,
    width: 60.44,
    height: 48.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.01125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 236.515
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 260.56,
    width: 60.44,
    height: 48.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.918571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 284.775
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 308.99,
    width: 60.44,
    height: 49.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0528571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 333.675
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 358.36,
    width: 60.44,
    height: 50.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.198333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 383.55
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 408.73,
    width: 60.44,
    height: 66.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.073333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 441.815
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 474.9,
    width: 60.44,
    height: 67.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 508.47999999999996
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 542.06,
    width: 60.44,
    height: 73.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 578.775
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.06,
    y: 615.48,
    width: 60.44,
    height: 84.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.28,
    y: 657.74
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 41.25,
    width: 59.07,
    height: 86.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.907
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.035,
    y: 84.65
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.57,
    y: 41.25,
    width: 59.81,
    height: 86.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4372727272727275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.475,
    y: 84.65
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.38,
    y: 41.25,
    width: 62.08,
    height: 86.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.346666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.42,
    y: 84.65
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.46,
    y: 41.25,
    width: 69,
    height: 86.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 298.96,
    y: 84.65
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.46,
    y: 41.25,
    width: 73.54,
    height: 86.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.256666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.22999999999996,
    y: 84.65
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.01,
    y: 41.25,
    width: 78.79,
    height: 86.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.255714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.405,
    y: 84.65
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.79,
    y: 41.25,
    width: 95.21,
    height: 86.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.466666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 533.395,
    y: 84.65
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581.01,
    y: 41.25,
    width: 118.99,
    height: 86.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.466666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.505,
    y: 84.65
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 128.05,
    width: 136.97,
    height: 97.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.1525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.985,
    y: 176.66000000000003
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 225.28,
    width: 136.97,
    height: 137.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.56714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.985,
    y: 294.2
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 363.12,
    width: 136.97,
    height: 142.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.828333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.985,
    y: 434.25
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 505.38,
    width: 136.97,
    height: 194.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.451818181818181
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.985,
    y: 602.69
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.48,
    y: 128.05,
    width: 142.09,
    height: 231.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.5225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.525,
    y: 243.82500000000002
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.57,
    y: 128.05,
    width: 166.68,
    height: 231.55,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 33.336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.90999999999997,
    y: 243.82500000000002
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.25,
    y: 128.05,
    width: 170.75,
    height: 231.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.458333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.625,
    y: 243.82500000000002
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.48,
    y: 359.61,
    width: 286.57,
    height: 149.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.63125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 363.765,
    y: 434.135
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.48,
    y: 508.66,
    width: 286.57,
    height: 191.34,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 363.765,
    y: 604.33
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.05,
    y: 359.61,
    width: 192.95,
    height: 340.39,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 38.589999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.525,
    y: 529.8050000000001
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1960);
export default __webpack_public_path__ + "static/media/1960.ae8fb3563a852d2030ce01dd7d476612.svg";
export { ForwardRef as ReactComponent };